import { render, staticRenderFns } from "./FormPresentation.vue?vue&type=template&id=05d5dd7b&scoped=true&"
import script from "./FormPresentation.vue?vue&type=script&lang=js&"
export * from "./FormPresentation.vue?vue&type=script&lang=js&"
import style0 from "./FormPresentation.vue?vue&type=style&index=0&id=05d5dd7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5dd7b",
  null
  
)

export default component.exports